/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyMonthlyUsageDto } from '../models/CompanyMonthlyUsageDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminCompanyUsageService {

  /**
   * @returns CompanyMonthlyUsageDto OK
   * @throws ApiError
   */
  public static getCompanyUsage({
    year,
    month,
  }: {
    year?: number,
    month?: number,
  }): CancelablePromise<Array<CompanyMonthlyUsageDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v2/admin/companyUsage',
      query: {
        'year': year,
        'month': month,
      },
    });
  }

}
